const ChartFilterEnum = {
    Desktop: "Desktop",
    Mobile: "Mobile"
}

export default ChartFilterEnum;
